import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      const currentElement = this.elementRef.nativeElement.querySelector('ion-input');
      if (currentElement) {
        currentElement.setFocus();
      } else {
        this.elementRef.nativeElement.setFocus();
      }
    }, 300);
  }
}
